import React, { Component } from "react";
import { Divider } from "styled_components/Common/Divider";
import { format } from "date-fns-tz/format";
import { BloxButton } from "styled_components/Common/BloxButton";
import { createTicketImage, getTicketTitle } from "utils/SupportUtils";
//import { formatInTimeZone } from 'date-fns-tz';

const CDN_URL = process.env.REACT_APP_CDN_URL;
const alertIcon = `${CDN_URL}common/tickets/icons-alert-reverse@3x.png`;

class NewTicket extends Component {
  constructor(props) {
    super(props);
    this.state = { numberColor: "#5b595b", clicked: false, active: false };
  }

  componentDidMount() {
    this.checkStatus();
  }
  componentDidUpdate(prevProps) {
    if (prevProps) {
      this.checkStatus(prevProps.ticket.status);
    }
  }
  checkStatus = (prevStatus) => {
    const { ticket } = this.props;
    let { status } = ticket;
    if (
      status === "In Progress" ||
      status === "Pending Review" ||
      status === "Waiting for Response" ||
      status === "Waiting for Confirmation" ||
      status === "Waiting for Agent Response"
    ) {
      status = "new";
    }
    const newTicketStatus = this.refs.ticketStatus;
    if (status !== prevStatus) {
      try {
        status = status.replace(" ", "");
        status = status.replace(" ", "");
        newTicketStatus.classList.add(status.toLowerCase());
        newTicketStatus.classList.remove(prevStatus);
      } catch (e) {
        console.log(e);
      }
    }
  };

  ticketDescription = (description) => {
    if (description) {
      if (description.length >= 28) {
        return `${description.substring(0, 28)}...`;
      } else {
        return description;
      }
    }
  };

  constructTicketTypeElements() {
    const { ticket, active } = this.props;

    const type = createTicketImage(ticket?.name);

    return (
      <div ref={"icon"} className="new-ticket-icon">
        <img
          ref={"image"}
          className="new-ticket-type"
          id={ticket.id}
          src={active ? type.imageInvert : type.image}
          alt=""
        />
      </div>
    );
  }

  getTicketStatus = (status) => {
    if (!status) {
      return "No Status";
    }
    if (
      status &&
      status !== "Waiting for Confirmation" &&
      status !== "Waiting for Agent Response"
    ) {
      return status.toUpperCase();
    } else {
      return "New";
    }
  };

  render() {
    const { ticket, clickHandler, id, selector } = this.props;
    const { active: activeState, numberColor } = this.state;

    const ticketStatus = this.getTicketStatus(ticket.status);
    //const startDate = new Date(ticket?.startDate);

    return (
      <div
        className="new-ticket-wrapper"
        id={id}
        //onClick={() => clickHandler(ticket)}
        data-cy={`ticket-${selector}`}
      >
        {this.constructTicketTypeElements()}
        <div
          ref={"ticketText"}
          className="new-ticket-type"
          id={`${ticket.id}new-ticket-type`}
          style={{ color: activeState ? "#ffffff" : numberColor }}
        >
          <div className="new-ticket-title">{getTicketTitle(ticket?.name)}</div>
        </div>
        {/* <div className='new-ticket-description footer20'>
					{this.ticketDescription(ticket.description)}
				</div> */}
        <div className="new-ticket-middle-section">
          <Divider />
          <div className="ticket-row">
            <span className="label labels21">TICKET # :</span>
            <span className="value footer20" data-cy={`ticket-id-${selector}`}>
              {ticket.id}
            </span>
          </div>

          <div className="ticket-row">
            <span className="label labels21">PRIORITY:</span>
            <span className="value footer20">
              {ticket.priority}
              <br />
            </span>
          </div>
          <div className="ticket-row">
            <span className="label labels21">OPENED:</span>
            <span className="value footer20">
              {format(new Date(ticket.startDate), "MM/dd/yy")}
              <br />
            </span>
          </div>
          {/* <div className='row-3'>
						<span className='ticket-time body10'>
							{' '}
							{formatInTimeZone(startDate, 'America/New_York', 'hh:mm a')}
						</span>
					</div> */}
        </div>
        <div ref="ticketStatus" className="new-ticket-status">
          <Divider />
          {ticket.status === "escalated" ? <img src={alertIcon} /> : ""}
          <span>{ticketStatus}</span>
        </div>
        <div className="hover">
          <div className="description footer20">{ticket?.description}</div>
          <BloxButton
            id="quick-view-button"
            text="View"
            module="support"
            enabled={true}
            onClick={() => clickHandler(ticket)}
            cypressId={`quick-view-${selector}`}
            className="buttons41"
          />
        </div>
      </div>
    );
  }
}

export default NewTicket;
